//SMObjectives
import smoImg_ch from "../images/smartmanufacturing/SmartManufacturingObjectives_CIMG.png";
import smoImg_en from "../images/smartmanufacturing/SmartManufacturingObjectives_EnIMG.png";

import smoSmallImg0 from "../images/smartmanufacturing/SmartAutomation.png";
import smoSmallImg1 from "../images/smartmanufacturing/SmartMachines.png";
import smoSmallImg2 from "../images/smartmanufacturing/SmartManagement.png";
import smoSmallImg3 from "../images/smartmanufacturing/SmartService.png";

//SMSmartAutomation
import smsaSmallImg0_ch from "../images/smartmanufacturing/SmartAutomation/SmartAutomation_CN.png";
import smsaSmallImg0_en from "../images/smartmanufacturing/SmartAutomation/SmartAutomation_EN.png";

import smsaSmallImg1_ch from "../images/smartmanufacturing/SmartAutomation/SmartAutomation2_CN.png";
import smsaSmallImg1_en from "../images/smartmanufacturing/SmartAutomation/SmartAutomation2_EN.png";

//SMSmartMachines
import smsmImg_ch from "../images/smartmanufacturing/SmartMachines/SmartMachines_CN.png";
import smsmImg_en from "../images/smartmanufacturing/SmartMachines/SmartMachines_EN.png";

//SMSmartManagement
import smsmtImg_ch from "../images/smartmanufacturing/SmartManagement/SmartManagement_CN.png";
import smsmtImg_en from "../images/smartmanufacturing/SmartManagement/SmartManagement_EN.png";

//SMSmartService
import smssImg0_ch from "../images/smartmanufacturing/SmartService/smart_service_1_CH.png";
import smssImg0_en from "../images/smartmanufacturing/SmartService/smart_service_1_EN.png";
import smssImg1_ch from "../images/smartmanufacturing/SmartService/smart_service_2_CH.png";
import smssImg1_en from "../images/smartmanufacturing/SmartService/smart_service_2_EN.png";

const smartManufacturingConfig = {
    SMObjectives:{
        ch:{
            title:'智慧智造目的',
            img:smoImg_ch,
            smallImg:[smoSmallImg0, smoSmallImg1, smoSmallImg2, smoSmallImg3],
            videoUrl:'https://www.youtube.com/watch?v=kkRFJt4hk2A&feature=youtu.be'
        },
        en:{
            title:'Smart Manufacturing',
            img:smoImg_en,
            smallImg:[smoSmallImg0, smoSmallImg1, smoSmallImg2, smoSmallImg3],
            videoUrl:'https://www.youtube.com/watch?v=YWWdNQRh2DI&feature=youtu.be'
        }
    },
    
    SMSmartAutomation:{
        ch:{
            title:'智慧自動化',
            img0:smsaSmallImg0_ch,
            img1:smsaSmallImg1_ch,
            videoUrl:'https://www.youtube.com/watch?v=ms6pJAC2Qh4&feature=youtu.be'
        },
        en:{
            title:'Smart Automation',
            img0:smsaSmallImg0_en,
            img1:smsaSmallImg1_en,
            videoUrl:'https://www.youtube.com/watch?v=u7TihwSPZJg&feature=youtu.be&ab_channel=YCM%E6%B0%B8%E9%80%B2%E6%A9%9F%E6%A2%B0'
        }
    },
    
    SMSmartMachines:{
        ch:{
            title:'智慧設備',
            img:smsmImg_ch,
            demoUrl:'https://www.ycmcnc.com/_upload/i%20Pros%20MX%E5%9E%8B%E9%8C%84(%E6%A9%AB)%20-%20%E6%99%BA%E6%85%A7%E8%A8%AD%E5%82%99%E5%9E%8B%E9%8C%84.pdf',
            videoUrl:'https://www.youtube.com/watch?v=dCjo-Y6KyRI&feature=youtu.be'
        },
        en:{
            title:'Smart Machines',
            img:smsmImg_en,
            demoUrl:'',
            videoUrl:''
        }
    },
    
    SMSmartManagement:{
        ch:{
            title:'智慧管理',
            img:smsmtImg_ch,
            demoUrl:'https://www.ycmcnc.com/_upload/%E9%81%94%E6%98%93Flyer_R003.pdf',
            videoUrl:'https://www.youtube.com/watch?v=Q1q127zvcIc&feature=youtu.be'
        },
        en:{
            title:'Smart Management',
            img:smsmtImg_en,
            demoUrl:'',
            videoUrl:''
        }
    },

    SMSmartService:{
        ch:{
            title:'智慧服務',
            img0:smssImg0_ch,
            img1:smssImg1_ch,
            // demoUrl:'',
            // videoUrl:'',
        },
        en:{
            title:'Smart Service',
            img0:smssImg0_en,
            img1:smssImg1_en,
            // demoUrl:'',
            // videoUrl:'',
        }
    },
}

export default smartManufacturingConfig;